import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Suspense } from "react";

import "./vendor/bootstrap-5.3.0-alpha1-dist/css/bootstrap.min.css";
import "./assets/css/color_theme.css";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./Helper/Loader";
import AuthRoute from "./Authentication/AurhRoute";
import WithoutAuthRoute from "./Authentication/WithoutAuthRoute";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "./Service/ApiService";
import {
  setAccessToken,
  setBusinessToken,
  setInstitueLogo,
  setRegistrationFormUrl,
  setUser,
  setUtilities,
  setHeaderLogo,
  setHeaderName,
} from "./Redux/UserSlice";
import OldStyleComponent from "./StyleComponents.js/OldStyleComponent";
import NewStyleComponent from "./StyleComponents.js/NewStyleComponent";

// import './vendor/select2@4.1.0-rc.0/select2.min.css';




const HowRegister = React.lazy(() => import("./Login/HowRegister"));
const Register = React.lazy(() => import("./Login/RegisterFirst"));
const Login = React.lazy(() => import("./Login/Login"));
const VerifyOtp = React.lazy(() => import("./Login/VerifyOtp"));

const BasicDetail = React.lazy(() =>
  import("./MemberShipRegistration/BasicDetail")
);
const Contact = React.lazy(() => import("./MemberShipRegistration/Contact"));
const RegisterToKin = React.lazy(() =>
  import("./MemberShipRegistration/RegisterToKin")
);
const RegisterBeneficiary = React.lazy(() =>
  import("./MemberShipRegistration/RegisterBeneficiary")
);
const UploadDocument = React.lazy(() =>
  import("./MemberShipRegistration/UploadDocument")
);
const PreviewApplication = React.lazy(() =>
  import("./MemberShipRegistration/PreviewApplication")
);
const ApplicationSubmitted = React.lazy(() =>
  import("./MemberShipRegistration/ApplicatioSubmitted")
);

const ApplicationStatus = React.lazy(() =>
  import("./MemberShipRegistration/ApplicationStatus")
);

const MyProfileBasicDetail = React.lazy(() => import("./Profile/BasicDetails"));
const MyProfileContactDetail = React.lazy(() =>
  import("./Profile/ContactDetail")
);
const MyProfileNextOfKin = React.lazy(() => import("./Profile/NextOfKin"));
const MyProfileBeneFiciaries = React.lazy(() =>
  import("./Profile/Beneficiary")
);
const MyProfileAttachement = React.lazy(() => import("./Profile/Attachement"));
const MyProfileCertificates = React.lazy(() =>
  import("./Profile/Certificates")
);
const MyProfileRequests = React.lazy(() => import("./Profile/Requests"));
const MyProfileCpdPoints = React.lazy(() => import("./Profile/CpdPoints"));
const SetPassword = React.lazy(() => import("./Profile/SetPassword"));

const EditBasicDetails = React.lazy(() =>
  import("./ProfileEdit/EditBasicDetail")
);
const EditContactDetails = React.lazy(() =>
  import("./ProfileEdit/EditContactDetail")
);
const EditNextOfKin = React.lazy(() => import("./ProfileEdit/EditNextOfKin"));
const EditBeneficiary = React.lazy(() =>
  import("./ProfileEdit/EditBeneFiciary")
);
const EditAttachement = React.lazy(() =>
  import("./ProfileEdit/EditAttachement")
);

const ShareProfile = React.lazy(() => import("./Profile/ShareProfile"));

const EditProfileBasicDetails = React.lazy(() =>
  import("./EditProfile/BasicDetail")
);
const EditProfileNextOfKin = React.lazy(() =>
  import("./EditProfile/NextOfKin")
);

const Dashboard = React.lazy(() => import("./Dashboard/Dashboard"));
const DashboardNew = React.lazy(() => import("./Dashboard/DashboardNew"));

const MemberStatement = React.lazy(() =>
  import("./InvoicePayments/MemberStatement")
);
const Receipts = React.lazy(() => import("./InvoicePayments/Receipts"));
const Invoices = React.lazy(() => import("./InvoicePayments/Invoices"));

const MySubscription = React.lazy(() => import("./Benevolent/MySubscription"));
const LifeMemberShip = React.lazy(() => import("./Benevolent/LifeMemberShip"));
const MedicalAssistance = React.lazy(() =>
  import("./Benevolent/MedicalAssistance")
);
const AddMedicalAssistance = React.lazy(() =>
  import("./Benevolent/AddMedicalAssistance")
);
const AssistanceProgram = React.lazy(() =>
  import("./Benevolent/AssistanceProgram")
);

const MyPersonalCases = React.lazy(() =>
  import("./CaseManagement/MyPersonalCases")
);
const MyFinesCosts = React.lazy(() => import("./CaseManagement/MyFinesCosts"));
const CaseDtc = React.lazy(() => import("./CaseManagement/CaseDtc"));
const Complaints = React.lazy(() => import("./CaseManagement/Complaints"));
const Affidavits = React.lazy(() => import("./CaseManagement/Affidavits"));
const AccAffidavits = React.lazy(() =>
  import("./CaseManagement/AccAffidavits")
);

const PracticeLicense = React.lazy(() =>
  import("./MemberServices/PracticeLicenece")
);
const RequestForPracticeLicense = React.lazy(() =>
  import("./MemberServices/RequestForPracticeLicense")
);
const PracticeLicenseList = React.lazy(() =>
  import("./MemberServices/PracticeLicenseList")
);

const CertificateOfGood = React.lazy(() =>
  import("./MemberServices/CertificateOfGood")
);
const RequestForCertificatesOfGood = React.lazy(() =>
  import("./MemberServices/RequestForCertificateOfGood")
);
const CertificateOfGoodList = React.lazy(() =>
  import("./MemberServices/CertificateOfGoodList")
);

const OnlineId = React.lazy(() => import("./MemberServices/OnlineId"));
const RequestForOnlineId = React.lazy(() =>
  import("./MemberServices/RequestForOnlineId")
);
const OnlineIdList = React.lazy(() => import("./MemberServices/OnlineIdList"));

const MemberServiceRequests = React.lazy(() =>
  import("./MemberServices/Requests")
);
const SubmitMemberRequest = React.lazy(() =>
  import("./MemberServices/SubmitRequest")
);
const MemberRequestList = React.lazy(() =>
  import("./MemberServices/RequestList")
);
const CpdExemptionList = React.lazy(() =>
  import("./MemberServices/CpdExemptionList")
);
const SubmitCpdExemption = React.lazy(() =>
  import("./MemberServices/SubmitCpdExemption")
);

const AbaLifeMembership = React.lazy(() =>
  import("./MemberServices/AbaLifeMembership")
);
const RequestForLifeMembership = React.lazy(() =>
  import("./MemberServices/RequestForAbaLifeMembership")
);

const AbaAnnualSubscription = React.lazy(() =>
  import("./MemberServices/AbaAnnualSub")
);
const RequestForAnnualSusbcription = React.lazy(() =>
  import("./MemberServices/RequestForAnnualSub")
);

const MemberAppointments = React.lazy(() =>
  import("./MemberServices/Appointments")
);

const NoticeOfIntention = React.lazy(() =>
  import("./MemberServices/NoticeOfIntention")
);

const Events = React.lazy(() => import("./Event/Attendend"));
const Membership = React.lazy(() => import("./Membership/Membership"));

const LastExpense = React.lazy(() => import("./ApplicationForm/LastExpense"));
const EducationalAssistance = React.lazy(() =>
  import("./ApplicationForm/EducationalAssistance")
);

const PracticeStandardDashboard = React.lazy(() =>
  import("./PracticeStandard/Dashboard")
);
const PracticeStandardRegistration = React.lazy(() =>
  import("./PracticeStandard/Registration")
);
const PracticeStandardRegistrationList = React.lazy(() =>
  import("./PracticeStandard/RegistrationList")
);
const PracticeStandardCompliance = React.lazy(() =>
  import("./PracticeStandard/Compliance")
);
const PracticeStandardPreTrial = React.lazy(() =>
  import("./PracticeStandard/PreTrial")
);
const PracticeStandardPreTrialList = React.lazy(() =>
  import("./PracticeStandard/PreTrailList")
);
const PracticeStandardSensitization = React.lazy(() =>
  import("./PracticeStandard/Sensitization")
);
const PracticeStandardReport = React.lazy(() =>
  import("./PracticeStandard/Report")
);
const PracticeStandardPolicyDocuments = React.lazy(() =>
  import("./PracticeStandard/PolicyDocuments")
);

const ParliamentDashboard = React.lazy(() =>
  import("./Parliamentary/Dashboard")
);
const ParliamentBillNotice = React.lazy(() =>
  import("./Parliamentary/BillNotice")
);
const ParliamentMemberParticipation = React.lazy(() =>
  import("./Parliamentary/MemberParticipation")
);
const ParliamentSurvey = React.lazy(() => import("./Parliamentary/Survey"));
const ParliamentSurveyDetail = React.lazy(() =>
  import("./Parliamentary/SurveyDetail")
);
const ParliamentAppointments = React.lazy(() =>
  import("./Parliamentary/Appiontments")
);
const ParliamentArbitration = React.lazy(() =>
  import("./Parliamentary/Arbitration")
);

const Survey = React.lazy(() => import("./Survey/Home"));
const SurveyDetail = React.lazy(() => import("./Survey/Detail"));
const TakeSurvey = React.lazy(() => import("./Survey/TakeSurvey"));

const MemberParticipation = React.lazy(() =>
  import("./MemberParticipation/MemberParticipation")
);

const Home = React.lazy(() => import("./Homepages/Home"));
const MemberLogin = React.lazy(() => import("./Homepages/MemberLogin"));
const NewRegister = React.lazy(() => import("./Homepages/NewRegister"));
const ForgotPassword = React.lazy(() => import("./Homepages/ForgotPassword"));
const Faq = React.lazy(() => import("./Homepages/Faq"));
const SearchAdvocate = React.lazy(() => import("./Homepages/Advocate/Home"));
const Resources = React.lazy(() => import("./Homepages/Resources"));
const Downloads = React.lazy(() => import("./Homepages/Downloads"));
const HomeEvents = React.lazy(() => import("./Homepages/Events"));
const EventDetail = React.lazy(() => import("./Homepages/EventDetail"));
const EventDetailNew = React.lazy(() => import("./Event/EventDetailNew"));
const HomeContact = React.lazy(() => import("./Homepages/Contact"));
const RaiseComplaint = React.lazy(() => import("./Homepages/RaiseComplaint"));
const ReportQuack = React.lazy(() => import("./Homepages/ReportQuack"));
const ProBonoService = React.lazy(() => import("./Homepages/ProBonoService"));

const ElearningDashboard = React.lazy(() =>
  import("./ElearningCompliance/Dashboard")
);
const ElearningRegistration = React.lazy(() =>
  import("./ElearningCompliance/Registration/Home")
);
const ElearningFileReports = React.lazy(() =>
  import("./ElearningCompliance/FileReports/Home")
);

const AmlDashboard = React.lazy(() => import("./AML/Dashboard"));
const AmlAnnualReport = React.lazy(() => import("./AML/AnnualReport"));
const AmlSar = React.lazy(() => import("./AML/Sar"));
const AmlStr = React.lazy(() => import("./AML/Str"));
const AmlCtr = React.lazy(() => import("./AML/Ctr"));
const AMLReports = React.lazy(() => import("./AML/Reports"));
const AmlRegistration = React.lazy(() => import("./AML/Registration"));
const CtrList = React.lazy(() => import("./AML/CtrList"));
const StrList = React.lazy(() => import("./AML/StrList"));
const SarList = React.lazy(() => import("./AML/SarList"));
const AnnualReportList = React.lazy(() => import("./AML/AnnualReportList"));
const Document = React.lazy(() => import("./Documents/Documents"));
const Announcements = React.lazy(() => import("./Announcements/Announcements"));
const NewsUpdates = React.lazy(() => import("./NewsUpdates/NewsUpdates"));
const NewsCardDetails = React.lazy(() => import("./NewsUpdates/NewsCardDetails"));
const SetFirstPassword = React.lazy(() => import("./Homepages/SetFirstPassword"));

function App() {
  // const navigate = useNavigate()
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showTawk, setShowTawk] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const _token = urlParams.get("token");
  const business_token = useSelector(
    (state) => state?.userData?.business_token
  );

  const storageToken = useSelector((state) => state?.userData?.access_token);
  // console.log('Token', _token)

  useEffect(() => {
    window.$(document).on("click", ".dropdown_v02", function (e) {
      e.stopPropagation();
      window.$(".dropdown").removeClass("show");
      window.$("td").removeClass("action_show_td");
      window.$(this).parents(".dropdown").addClass("show");
      window.$(this).parents("td").addClass("action_show_td");
      window.$("body").addClass("dropdoenOpen");
    });

    if (_token) {
      dispatch(setAccessToken(_token));
      // getProfileData()
      // navigate('/dashboard')
    }
    // if (business_token) {
    //   dispatch(setBusinessToken(business_token))
    // }
  }, []);

  // Load Tawk.to script dynamically after first page load
  useEffect(() => {
    // Check if Tawk is already loaded to prevent duplicate loading
    if (!window.Tawk_API && showTawk) {  
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
      (function () {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/68f9cd43511129194ce124b2/1j87sjkf6';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      })();
    }
  }, [showTawk]); // Empty dependency array means this runs once after first render

  const getProfileData = async () => {
    try {
      setLoading(true);
      let data = await ApiService.request(
        "get",
        ApiService.config.getProfileDataApi,
        {
          // email: registerData?.email,
          // business_token: business_token,
          type: "all",
        }
      );
      if (data?.status) {
        dispatch(setUser(data?.data));
      } else {
        // toast.error(data?.message)
      }
    } catch (error) {
      // alert(1)
      dispatch(setUser({}));
      dispatch(setAccessToken(""));
      // dispatch(setBusinessToken(''))
      // setTimeout(() => {

      //   window.open('https://abnocloud.com/genesis_refresh_student_statement/', '_self')
      // }, 500)
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // alert(2)
    if (storageToken) {
      getProfileData();
    }
  }, [storageToken]);

  const getBusinessToken = async () => {
    try {
      let data = await ApiService.request(
        "post",
        ApiService.config.getBusinessTokenApi,
        {}
      );
      if (data?.status) {
        dispatch(setBusinessToken(data?.data?.business_token));
        dispatch(setInstitueLogo(data?.data?.logo))
        dispatch(setRegistrationFormUrl(data?.data?.registration_url))
        dispatch(setHeaderLogo(data?.data?.logo))
        dispatch(setHeaderName(data?.data?.business_name))
        
        // Update document title dynamically
        if (data?.data?.business_name) {
          document.title = data?.data?.business_name;
        }
        
        // Update favicon dynamically
        if (data?.data?.logo) {
          let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.rel = 'icon';
          link.href = data?.data?.logo;
          if (!document.querySelector("link[rel*='icon']")) {
            document.head.appendChild(link);
          }
        }
        
        if(data?.data?.enable_customer_support){
          setShowTawk(true);
        }
        // getUtilities(data?.data?.business_token)
      } else {
        // toast.error(data?.message)
      }
    } catch (error) {
    } finally {
      // setLoading(false)
    }
  };

  useEffect(() => {
    getBusinessToken();
  }, []);

  const getUtilities = async (token) => {
    try {
      setLoading(true);
      let data = await ApiService.request(
        "get",
        ApiService.config.getUtilitiesApi,
        {
          list: "all",
          business_token: token,
        }
      );
      if (data?.status) {
        dispatch(setUtilities(data?.data));
      } else {
        // toast.error(data?.message)
      }
    } catch (error) {
    } finally {
      // setLoading(false)
    }
  };

  // Scroll issue is fixed when offcanwas is open/close Start
  useEffect(() => {
    const handleShow = () => {
      document.documentElement.classList.add("offcanvas-open");
    };

    const handleHidden = () => {
      document.documentElement.classList.remove("offcanvas-open");
    };

    document.addEventListener("show.bs.offcanvas", handleShow);
    document.addEventListener("hidden.bs.offcanvas", handleHidden);

    // cleanup (VERY IMPORTANT)
    return () => {
      document.removeEventListener("show.bs.offcanvas", handleShow);
      document.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);
  // Scroll issue is fixed when offcanwas is open/close End

  useEffect(() => {
    if (business_token && storageToken) {
      getUtilities();
    }
  }, [business_token, storageToken]);

  return (
      <BrowserRouter basename={"/member"}>
      <ToastContainer />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<NewStyleComponent />}>
            <Route element={<WithoutAuthRoute />}>
              <Route path="/apply-now" element={<HowRegister />} />
              <Route path="/register" element={<Register />} />
              {/* <Route path='/' element={<Login />} /> */}
              <Route path="/verify-otp" element={<VerifyOtp />} />

              <Route
                path="/last-expense-application"
                element={<LastExpense />}
              />
              <Route
                path="/educational-assistance-application"
                element={<EducationalAssistance />}
              />

           <Route path="/" element={<MemberLogin />} />
            <Route path="/search-advocate" element={<SearchAdvocate />} />

              <Route path="/login" element={<MemberLogin />} />
              <Route path="/new-register" element={<NewRegister />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/set-first-password" element={<SetFirstPassword />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/home-events" element={<HomeEvents />} />
              <Route path="/event-detail" element={<EventDetail />} />
              <Route path="/home-contact" element={<HomeContact />} />
              <Route path="/raise-complaint" element={<RaiseComplaint />} />
              <Route path="/report-quack" element={<ReportQuack />} />
              <Route path="/legal-aid-service" element={<ProBonoService />} />
            </Route>
          </Route>

          <Route element={<OldStyleComponent />}>
            <Route element={<AuthRoute name="all" />}>
              <Route element={<AuthRoute name="application-status" />}>
                <Route
                  path="/application-status"
                  element={<ApplicationStatus />}
                />
              </Route>
              <Route element={<AuthRoute name="application_submission" />}>
                <Route path="/basic-detail" element={<BasicDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/register-to-kin" element={<RegisterToKin />} />
                <Route
                  path="/register-to-beneficiaries"
                  element={<RegisterBeneficiary />}
                />
                <Route path="/upload-document" element={<UploadDocument />} />
                <Route
                  path="/preview-application"
                  element={<PreviewApplication />}
                />
                <Route
                  path="/application-submitted"
                  element={<ApplicationSubmitted />}
                />
              </Route>
              <Route element={<AuthRoute name="dashboard" />}>
                <Route
                  path="/my-profile-basic-details"
                  element={<MyProfileBasicDetail />}
                />
                <Route
                  path="/my-profile-contact-details"
                  element={<MyProfileContactDetail />}
                />
                <Route
                  path="/my-profile-next-of-kin"
                  element={<MyProfileNextOfKin />}
                />
                <Route
                  path="/my-profile-beneficiaries"
                  element={<MyProfileBeneFiciaries />}
                />
                <Route
                  path="/my-profile-attachement"
                  element={<MyProfileAttachement />}
                />
                <Route
                  path="/my-profile-certificates"
                  element={<MyProfileCertificates />}
                />
                <Route
                  path="/my-profile-requests"
                  element={<MyProfileRequests />}
                />
                <Route
                  path="/my-profile-cpd-points"
                  element={<MyProfileCpdPoints />}
                />
                <Route
                  path="/set-password"
                  element={<SetPassword />}
                />

                <Route
                  path="/edit-basic-details"
                  element={<EditBasicDetails />}
                />
                <Route
                  path="/edit-contact-details"
                  element={<EditContactDetails />}
                />
                <Route path="/edit-next-of-kin" element={<EditNextOfKin />} />
                <Route path="/edit-beneficiary" element={<EditBeneficiary />} />
                <Route path="/edit-attachement" element={<EditAttachement />} />

                <Route path="/share-profile" element={<ShareProfile />} />

                <Route
                  path="/edit-profile-basic-details"
                  element={<EditProfileBasicDetails />}
                />
                <Route
                  path="/edit-profile-next-of-kin"
                  element={<EditProfileNextOfKin />}
                />

                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard-new" element={<DashboardNew />} />

                <Route path="/member-statement" element={<MemberStatement />} />
                <Route path="/receipts" element={<Receipts />} />
                <Route path="/invoices" element={<Invoices />} />

                <Route path="/my-subscription" element={<MySubscription />} />
                <Route path="/life-membership" element={<LifeMemberShip />} />
                <Route
                  path="/medical-assistance"
                  element={<MedicalAssistance />}
                />
                <Route
                  path="/add-medical-assistance"
                  element={<AddMedicalAssistance />}
                />
                <Route
                  path="/assistance-program"
                  element={<AssistanceProgram />}
                />

                <Route
                  path="/my-personal-cases"
                  element={<MyPersonalCases />}
                />
                <Route path="/my-fines-costs" element={<MyFinesCosts />} />
                <Route path="/case-dtc" element={<CaseDtc />} />
                <Route path="/complaints" element={<Complaints />} />
                <Route path="/affidavits" element={<Affidavits />} />
                <Route path="/acc-affidavits" element={<AccAffidavits />} />

                <Route path="/practice-license" element={<PracticeLicense />} />
                <Route
                  path="/request-practice-license"
                  element={<RequestForPracticeLicense />}
                />
                {/* <Route path='/practice-license-list' element={<PracticeLicenseList />} /> */}

                <Route
                  path="/certificate-of-good"
                  element={<CertificateOfGood />}
                />
                <Route
                  path="/request-certificate-of-good"
                  element={<RequestForCertificatesOfGood />}
                />
                {/* <Route path='/certificate-of-good-list' element={<CertificateOfGoodList />} /> */}

                <Route path="/online-id" element={<OnlineId />} />
                <Route
                  path="/request-for-online-id"
                  element={<RequestForOnlineId />}
                />
                {/* <Route path='/online-id-list' element={<OnlineIdList />} /> */}

                <Route
                  path="/aba-life-membership"
                  element={<AbaLifeMembership />}
                />
                <Route
                  path="/request-aba-life-membership"
                  element={<RequestForLifeMembership />}
                />

                <Route
                  path="/aba-annual-subscription"
                  element={<AbaAnnualSubscription />}
                />
                <Route
                  path="/request-aba-annual-subscription"
                  element={<RequestForAnnualSusbcription />}
                />

                {/* <Route path='/member-service-requests' element={<MemberServiceRequests />} /> */}
                <Route
                  path="/submit-member-service-requests"
                  element={<SubmitMemberRequest />}
                />
                <Route
                  path="/member-service-request-list"
                  element={<MemberRequestList />}
                />
                <Route
                  path="/cpd-exemption"
                  element={<CpdExemptionList />}
                />
                <Route
                  path="/submit-cpd-exemption"
                  element={<SubmitCpdExemption />}
                />

                <Route
                  path="/member-appointments"
                  element={<MemberAppointments />}
                />

                <Route
                  path="/notice-of-intention"
                  element={<NoticeOfIntention />}
                />

                <Route path="/events" element={<Events />} />
                <Route path="/event-detail-new" element={<EventDetailNew />} />
                <Route path="/membership" element={<Membership />} />

                <Route path="/documents" element={<Document />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/news-updates" element={<NewsUpdates />} />
                <Route path="/news-card-details/:id" element={<NewsCardDetails />} />

                <Route path="/survey" element={<Survey />} />
                <Route path="/take-survey/:slug" element={<TakeSurvey />} />
                
                <Route path="/survey-detail/:slug" element={<SurveyDetail />} />

                <Route
                  path="/practice-standard-dashboard"
                  element={<PracticeStandardDashboard />}
                />
                <Route
                  path="/practice-standard-registration"
                  element={<PracticeStandardRegistration />}
                />
                <Route
                  path="/practice-standard-registration/:slug"
                  element={<PracticeStandardRegistration />}
                />
                <Route
                  path="/practice-standard-registration-list"
                  element={<PracticeStandardRegistrationList />}
                />
                <Route
                  path="/practice-standard-compliance"
                  element={<PracticeStandardCompliance />}
                />
                <Route
                  path="/practice-standard-pretrial"
                  element={<PracticeStandardPreTrial />}
                />
                <Route
                  path="/practice-standard-pretrial/:slug"
                  element={<PracticeStandardPreTrial />}
                />
                <Route
                  path="/practice-standard-pretrial-list"
                  element={<PracticeStandardPreTrialList />}
                />
                <Route
                  path="/practice-standard-sensitization"
                  element={<PracticeStandardSensitization />}
                />
                <Route
                  path="/practice-standard-report"
                  element={<PracticeStandardReport />}
                />
                <Route
                  path="/practice-standard-policy-documents"
                  element={<PracticeStandardPolicyDocuments />}
                />

                <Route
                  path="/parliament-dashboard"
                  element={<ParliamentDashboard />}
                />
                <Route
                  path="/parliament-bill-notice"
                  element={<ParliamentBillNotice />}
                />
                <Route
                  path="/parliament-member-participation"
                  element={<ParliamentMemberParticipation />}
                />
                <Route
                  path="/parliament-survey"
                  element={<ParliamentSurvey />}
                />
                <Route
                  path="/parliament-survey-detail/:slug"
                  element={<ParliamentSurveyDetail />}
                />
                <Route
                  path="/parliament-appointments"
                  element={<ParliamentAppointments />}
                />
                <Route
                  path="/parliament-arbitration"
                  element={<ParliamentArbitration />}
                />
                {/* <Route path='/parliament-bill-notice' element={<ParliamentDashboard />} /> */}

                <Route
                  path="/member-participation"
                  element={<MemberParticipation />}
                />

                <Route
                  path="/elearning-dashboard"
                  element={<ElearningDashboard />}
                />
                <Route
                  path="/elearning-registration"
                  element={<ElearningRegistration />}
                />
                <Route
                  path="/elearning-file-reports"
                  element={<ElearningFileReports />}
                />

                <Route path="/aml-dashboard" element={<AmlDashboard />} />
                <Route
                  path="/aml-annual-report"
                  element={<AmlAnnualReport />}
                />
                <Route path="/aml-sar" element={<AmlSar />} />
                <Route path="/aml-str" element={<AmlStr />} />
                <Route path="/aml-ctr" element={<AmlCtr />} />
                <Route path="/aml-reports" element={<AMLReports />} />
                <Route
                  path="/aml-registration"
                  element={<AmlRegistration />}
                />
              </Route>
              <Route path="/ctr-list" element={<CtrList />} />
              <Route path="/str-list" element={<StrList />} />
              <Route path="/sar-list" element={<SarList />} />
              <Route path="/annual-report-list" element={<AnnualReportList />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
